import { render, staticRenderFns } from "./Q&A.vue?vue&type=template&id=e4c5391c&"
import script from "./Q&A.vue?vue&type=script&lang=js&"
export * from "./Q&A.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports